import React from "react";
import { classNames } from "src/helpers/classNames";

export default function ToggleHeader({ title = "", subtitle = "", icon = null, children, position = "left", titleClassName = "", subcontainerClasses = "", headerContainerClassName, subtitleClasses }) {
  return (
    <div className={classNames("mb-4 flex w-full font-medium text-gray-600", headerContainerClassName)}>
      <div className={classNames("flex items-center gap-x-5", position === "right" ? "" : "flex-row-reverse", subcontainerClasses)}>
        <div className="flex flex-col">
          <div className="flex items-center gap-x-2">
            {icon && <span className="h-5 w-5 text-gray-500">{icon}</span>}
            <p className={classNames(titleClassName)}>{title}</p>
          </div>
          <p className={classNames("text-sm text-gray-400", subtitleClasses)}>{subtitle}</p>
        </div>
        {children}
      </div>
    </div>
  );
}
